import { render, staticRenderFns } from "./RemoteActions.vue?vue&type=template&id=52c139f9&"
import script from "./RemoteActions.vue?vue&type=script&lang=js&"
export * from "./RemoteActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports